import { useResolveRoute } from '@mews/routing';
import { lt } from '@mews/framework';
import { RouteName, ActionType } from '@mews-commander/enums';
import { IconName } from '@optimus-web/icons';
import { getCurrentEnterpriseUserPreferredServiceId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';
import { HeadingAction } from '../../../legacy/React/Components/HeadingAction/Action/types';

export const useHeadingActions = () => {
    const resolveRoute = useResolveRoute();
    const serviceId = useCommanderSelector(getCurrentEnterpriseUserPreferredServiceId);
    const url = resolveRoute(RouteName.GuestInHouseReportIndex, { query: { 'Service.Id': serviceId } });

    const actions = [
        {
            type: ActionType.Link,
            icon: IconName.Home,
            text: lt('GuestInHouseReportViewOldReportActionTooltip'),
            url,
        },
    ] satisfies HeadingAction[];

    return actions;
};
